export default __webpack_public_path__ + "static/website-building-6d217b44c856cd522bd237fe8a3e5dfb.svg";